function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.888 35.25V19.186h5.416l.78-6.289h-6.196V8.904c0-.918.191-1.66.573-2.226.383-.566 1.217-.849 2.502-.849h3.305v-5.6c-.796-.061-1.599-.114-2.41-.16A42.544 42.544 0 0 0 13.448 0c-2.386 0-4.33.711-5.829 2.134C6.12 3.557 5.37 5.615 5.37 8.308v4.589H0v6.289h5.37V35.25h6.518Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(.65466 0 0 .65466 6.475 0)"
  }));
};

export default SvgSocialFacebook;